import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  typical_position_size: {
    name: 'Typical deal or position size',
    order: 70,
    letter: 'A'
  }
};

export function TypicalPositionSize({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.TYPICAL_POSITION_SIZE,
    onChangeFund,
    schema: schema.TYPICAL_POSITION_SIZE,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.TYPICAL_POSITION_SIZE?.field_names || [],
    tableName: 'TYPICAL_POSITION_SIZE',
    columnLables,
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="fca-reporttables-typical-position-size-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
